import { render } from "./ImageUploader.vue?vue&type=template&id=d8c215f4&scoped=true&ts=true"
import script from "./ImageUploader.vue?vue&type=script&lang=ts"
export * from "./ImageUploader.vue?vue&type=script&lang=ts"

import "./ImageUploader.vue?vue&type=style&index=0&id=d8c215f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8c215f4"]])

export default __exports__